import { call, put } from 'redux-saga/effects';
import { clearUserCredentials } from '../../state/userCredential/userCredentialSlice';
import { clearDeviceCredentials } from '../../state/device/deviceSlice';
import { resetNotifications } from '../../state/notification/notificationSlice';
import { resetCallSessions } from '../../state/callSessions/callSessionsSlice';
import { resetActiveCallScreen } from '../../state/activeCallScreen/activeCallScreenSlice';
import { resetMessageSession } from '../../state/message/messageSessionSlice';
import { resetMessages } from '../../state/message/messageSlice';
import { resetAnalyticAdmin } from '../../state/analytic/analyticAdminSlice';
import { resetAnalyticTeam } from '../../state/analytic/analyticTeamSlice';
import { resetAnalyticTeamMember } from '../../state/analytic/analyticTeamMemberSlice';
import { resetAnalyticTeamReportConfig } from '../../state/analytic/analyticTeamReportSlice';
import { resetUserAnalyticData } from '../../state/analytic/analyticUserDataSlice';
import { resetTeamAnalyticData } from '../../state/analytic/analyticTeamDataSlice';
import { resetDomainAnalyticData } from '../../state/analytic/analyticDomainDataSlice';
import { resetAnalyticSubscriptionUsage } from '../../state/analytic/analyticSubscriptionUsageSlice';
import { resetAssistantQuota } from '../../state/assistant/assistantQuotaSlice';
import { resetCallRecording } from '../../state/callRecording/callRecordingSlice';
import { resetDomainInfo } from '../../state/callCenter/domainInfoSlice';
import { resetActiveDomainCall } from '../../state/callCenter/activeDomainCall';
import { resetDomainCallCount } from '../../state/callCenter/domainCallCountSlice';
import { resetUserCallReport } from '../../state/callCenter/userCallReportSlice';
import { resetDomainCallReport } from '../../state/callCenter/domainCallReportSlice';
import { persistor } from '../../state/store';
import { socketDisconnectAction } from '../socket/socketDisconnect/action';
import { disconnectSseAction } from '../sse/connectSse/action';
import { cleanupUASaga } from '../userAgent/cleanupUA/cleanupUA';
import { clearFeedback } from '../../state/feedback/feedbackSlice';
import { clearIntegration } from '../../state/integration/integrationSlice';
import { clearAllSnackbars } from '../../state/snackbar/snackbarSlice';
import { logout } from '../../state/login/loginSlice';
import { handleLogout } from '../../browser/lifecycle';
import { backendClient } from '../../services/api/backend-client';

export function* logoutSaga() {
    try {

        // Dispatch socket disconnect action
        yield put(socketDisconnectAction());
        yield put(disconnectSseAction());

        // Tell backend to clear the HttpOnly refresh_token cookie. Best-effort —
        // local logout proceeds even if the call fails (offline, 5xx, etc.).
        try {
            yield call([backendClient, backendClient.post], 'auth/logout');
        } catch (err) {
            console.warn('Backend logout failed; proceeding with local cleanup:', err?.message);
        }

        // Clear platform store
        yield call(handleLogout);

        // Clear Redux store
        yield put(resetNotifications());
        yield put(clearUserCredentials());
        yield put(clearDeviceCredentials());
        yield put(resetMessageSession());
        yield put(resetMessages())
        yield put(resetActiveCallScreen());
        yield put(resetAnalyticAdmin());
        yield put(resetUserAnalyticData());
        yield put(resetTeamAnalyticData());
        yield put(resetDomainAnalyticData());
        yield put(resetAnalyticSubscriptionUsage());
        yield put(resetAnalyticTeam());
        yield put(resetAnalyticTeamMember());
        yield put(resetAnalyticTeamReportConfig());
        yield put(resetAssistantQuota());
        yield put(resetCallRecording());
        yield put(resetActiveDomainCall());
        yield put(resetDomainInfo());
        yield put(resetDomainCallCount());
        yield put(resetUserCallReport());
        yield put(resetDomainCallReport());

        // Set logged out state
        yield put(logout());

        // Clean up User Agent and Call Sessions
        yield call(cleanupUASaga);
        yield put(resetCallSessions());

        // Clear up Integration data
        yield put(clearIntegration());

        // Clear up Feedback
        yield put(clearFeedback());

        // Clear up Snackbar
        yield put(clearAllSnackbars())

        // Purge Redux-persist
        yield call(persistor.purge);

        // Reload to drop stale in-memory state (e.g. BroadcastChannel listeners).
        if (typeof window !== 'undefined') window.location.reload();

    } catch (error) {
        console.error('Logout failed:', error);
    }
}